// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"539d77d8","787":"b97b9838"}[chunkId] + ".chunk.js";
};